// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3xbIp","validationTips":"StatementDescriptor_validationTips__QM3-x"};